interface ErrorResponse {
  message: string
  details?: string
}

export const handleApiError = (error: any, endpoint: string): ErrorResponse => {
  console.error(`Error calling ${endpoint}:`, error)

  switch (endpoint) {
    case 'health':
      return {
        message: 'Service is currently unavailable',
        details: 'Please try again later',
      }
    case 'chat':
      return {
        message:
          'We’re sorry! It seems we’re having a little trouble connecting right now. You can check out opportunities and information on our career site while we sort this out',
        details: '',
      }
    case 'feedback':
      return {
        message: 'Unable to submit feedback',
        details: 'Your feedback could not be recorded at this time',
      }
    default:
      return {
        message: 'Something went wrong',
        details: 'Please try again later',
      }
  }
}
